import React from 'react';
import styled from 'styled-components';
import privacyPolicyContent from './privacyPolicyContent';

// スタイル付きのコンポーネントを作成します
const PrivacyPolicyContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
`;

const Heading = styled.h1`
  font-size: 24px;
  margin-bottom: 20px;
`;

const Paragraph = styled.p`
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 10px;

  @media (max-width: 600px) {
    font-size: 14px;
  }
`;

const Link = styled.a`
  color: #007bff;
  text-decoration: underline;
`;

const SitePrivacyPolicyBody = () => {
    return (
        <PrivacyPolicyContainer>
            <Heading>プライバシーポリシー</Heading>
            {/* <Paragraph>{privacyPolicyContent.purpose}</Paragraph> */}
            <Heading>{privacyPolicyContent.purpose.title}</Heading>
            <Paragraph>{privacyPolicyContent.purpose.body}</Paragraph>
            <Heading>{privacyPolicyContent.disclosure.title}</Heading>
            <Paragraph>{privacyPolicyContent.disclosure.body}</Paragraph>
            <ul>
                {privacyPolicyContent.disclosure.items.map((item, index) => (
                    <li key={index}>{item}</li>
                ))}
            </ul>
            <Paragraph>{privacyPolicyContent.disclosure.additionalNote}</Paragraph>
            <Heading>{privacyPolicyContent.advertising.title}</Heading>
            <Paragraph>{privacyPolicyContent.advertising.body}
                <Link href="https://policies.google.com/technologies/ads?gl=jp" target="_blank" rel="noopener noreferrer">
                    こちら
                </Link>
                {privacyPolicyContent.advertising.additionalNote}
            </Paragraph>
            <Heading>{privacyPolicyContent.analyticsTool.title}</Heading>
            <Paragraph>{privacyPolicyContent.analyticsTool.body}
                詳細は
                <Link href="https://marketingplatform.google.com/about/analytics/terms/jp/" target="_blank" rel="noopener noreferrer">
                    Google アナリティクス利用規約
                </Link>
                や
                <Link href="https://policies.google.com/technologies/ads?hl=ja" target="_blank" rel="noopener noreferrer">
                    Googleポリシーと規約
                </Link>
                をご覧ください。
            </Paragraph>
            <Heading>{privacyPolicyContent.copyright.title}</Heading>
            <Paragraph>{privacyPolicyContent.copyright.body}</Paragraph>
            <Heading>{privacyPolicyContent.cookie.title}</Heading>
            <Paragraph>{privacyPolicyContent.cookie.body}</Paragraph>
            <Heading>{privacyPolicyContent.disclaimer.title}</Heading>
            <Paragraph>{privacyPolicyContent.disclaimer.body}</Paragraph>
            <Heading>{privacyPolicyContent.privacyPolicyChanges.title}</Heading>
            <Paragraph>{privacyPolicyContent.privacyPolicyChanges.body}</Paragraph>
        </PrivacyPolicyContainer>
    );
};

export default SitePrivacyPolicyBody;
